var _mask, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckmarkEnclosedFilled = function SvgCheckmarkEnclosedFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.5 6L8.5 12L5.5 9L4 10.5L8.5 15L16 7.5L14.5 6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.5 6L8.5 12L5.5 9L4 10.5L8.5 15L16 7.5L14.5 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12L7.43934 13.0607L8.5 14.1213L9.56066 13.0607L8.5 12ZM14.5 6L15.5607 4.93934L14.5 3.87868L13.4393 4.93934L14.5 6ZM5.5 9L6.56066 7.93934L5.5 6.87868L4.43934 7.93934L5.5 9ZM4 10.5L2.93934 9.43934L1.87868 10.5L2.93934 11.5607L4 10.5ZM8.5 15L7.43934 16.0607L8.5 17.1213L9.56066 16.0607L8.5 15ZM16 7.5L17.0607 8.56066L18.1213 7.5L17.0607 6.43934L16 7.5ZM18.5 10C18.5 14.6944 14.6944 18.5 10 18.5V21.5C16.3513 21.5 21.5 16.3513 21.5 10H18.5ZM10 1.5C14.6944 1.5 18.5 5.30558 18.5 10H21.5C21.5 3.64873 16.3513 -1.5 10 -1.5V1.5ZM1.5 10C1.5 5.30558 5.30558 1.5 10 1.5V-1.5C3.64873 -1.5 -1.5 3.64873 -1.5 10H1.5ZM10 18.5C5.30558 18.5 1.5 14.6944 1.5 10H-1.5C-1.5 16.3513 3.64873 21.5 10 21.5V18.5ZM9.56066 13.0607L15.5607 7.06066L13.4393 4.93934L7.43934 10.9393L9.56066 13.0607ZM4.43934 10.0607L7.43934 13.0607L9.56066 10.9393L6.56066 7.93934L4.43934 10.0607ZM5.06066 11.5607L6.56066 10.0607L4.43934 7.93934L2.93934 9.43934L5.06066 11.5607ZM9.56066 13.9393L5.06066 9.43934L2.93934 11.5607L7.43934 16.0607L9.56066 13.9393ZM14.9393 6.43934L7.43934 13.9393L9.56066 16.0607L17.0607 8.56066L14.9393 6.43934ZM13.4393 7.06066L14.9393 8.56066L17.0607 6.43934L15.5607 4.93934L13.4393 7.06066Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkEnclosedFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark-enclosed-filled.8a22c224.svg";
export { ForwardRef as ReactComponent };